export default __webpack_public_path__ + "e42b7c2a136093d5d7c0e8307ff84ef5.svg";